<template>
  <div class="import-page">
    <section class="import-card">
      <div class="import-header">
        <div>
          <span>Institucional</span>
          <h1>Importar configuração por JSON</h1>
        </div>
        <div class="header-actions">
          <button class="btn btn-outline-secondary" type="button" @click="CarregarStatus">
            Atualizar
          </button>
          <button class="btn btn-outline-primary" type="button" :disabled="!PodeExportarFrontend" @click="GerarJsonFrontend">
            Gerar JSON Front Vue
          </button>
        </div>
      </div>

      <div v-if="Status" class="status-grid">
        <article>
          <span>Grupos</span>
          <strong>{{ Status.grupos }}</strong>
        </article>
        <article>
          <span>Telas</span>
          <strong>{{ Status.telas }}</strong>
        </article>
        <article>
          <span>Configurações</span>
          <strong>{{ Status.configuracoes }}</strong>
        </article>
        <article>
          <span>Listas</span>
          <strong>{{ totalListas }}</strong>
        </article>
        <article>
          <span>Dados INS</span>
          <strong>{{ totalDados }}</strong>
        </article>
      </div>

      <div v-if="Status" class="status-message" :class="{ blocked: Status.temCarga || Status.temDados }">
        {{ MensagemFluxoImportacao }}
      </div>

      <div v-if="Status && totalDados > 0" class="status-message blocked">
        Existem dados institucionais cadastrados nas tabelas ins. A próxima importação vai apagar esses dados e carregar somente a configuração do JSON.
      </div>

      <div class="import-actions">
        <label class="file-picker">
          <input type="file" accept="application/json,.json" @change="SelecionarArquivo">
          <span>{{ NomeArquivo || 'Selecionar JSON' }}</span>
        </label>
        <button class="btn btn-success" type="button" :disabled="!PodeImportarArquivo" @click="Importar">
          Substituir e importar JSON
        </button>
      </div>

      <div v-if="JsonImportacao" class="status-message">
        JSON selecionado: {{ TotalGruposArquivo }} grupo(s), {{ TotalTelasArquivo }} tela(s) e {{ TotalLayoutMapArquivo }} item(ns) de mapa do layout.
      </div>
    </section>

    <section class="import-card danger-card">
      <div class="import-header">
        <div>
          <span>Limpeza</span>
          <h2>Zerar carga institucional</h2>
        </div>
        <button class="btn btn-danger" type="button" :disabled="!PodeLimpar" @click="LimparCarga">
          Limpar tudo
        </button>
      </div>
      <p v-if="Status" class="clean-message">{{ Status.mensagemLimpeza }}</p>
    </section>

    <section v-if="Resultado" class="import-card">
      <h2>Resultado</h2>
      <div class="result-grid">
        <span>Grupos: {{ Resultado.gruposProcessados }}</span>
        <span>Telas: {{ Resultado.telasProcessadas }}</span>
        <span>Configurações: {{ Resultado.configuracoesProcessadas }}</span>
        <span>Listas imagens: {{ Resultado.listasImagensProcessadas }}</span>
        <span>Listas arquivos: {{ Resultado.listasArquivosProcessadas }}</span>
        <span>Listas grids: {{ Resultado.listasGridsProcessadas }}</span>
        <span>Conteúdos: {{ Resultado.conteudosProcessados }}</span>
        <span>Segmentos: {{ Resultado.segmentosProcessados }}</span>
        <span>Registros limpos: {{ Resultado.registrosLimpos }}</span>
        <span>Usuários liberados: {{ Resultado.usuariosPermissaoProcessados }}</span>
        <span>Permissões: {{ Resultado.permissoesProcessadas }}</span>
      </div>
      <ul v-if="Resultado.avisos && Resultado.avisos.length" class="warning-list">
        <li v-for="aviso in Resultado.avisos" :key="aviso">{{ aviso }}</li>
      </ul>
    </section>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ImportacaoInstitucionalView',
  data: () => ({
    Status: null,
    JsonImportacao: null,
    NomeArquivo: '',
    Resultado: null,
  }),
  computed: {
    totalListas() {
      if (!this.Status) {
        return 0;
      }

      return this.Status.listasImagens + this.Status.listasArquivos + this.Status.listasGrids;
    },
    totalDados() {
      if (!this.Status) {
        return 0;
      }

      return this.Status.conteudos + this.Status.imagens + this.Status.arquivos +
        this.Status.grids + this.Status.gridImagens + this.Status.segmentos +
        this.Status.segmentosImagens + this.Status.segmentosArquivos + this.Status.conteudosSegmentos;
    },
    PodeImportarArquivo() {
      return !!this.JsonImportacao;
    },
    PodeLimpar() {
      return this.Status && this.Status.podeLimpar;
    },
    PodeExportarFrontend() {
      return this.Status && this.Status.temCarga;
    },
    TotalGruposArquivo() {
      return (this.JsonImportacao?.grupos || []).length;
    },
    TotalTelasArquivo() {
      return (this.JsonImportacao?.grupos || []).reduce((total, grupo) => total + (grupo.telas || []).length, 0);
    },
    TotalLayoutMapArquivo() {
      return (this.JsonImportacao?.layoutMap || []).length;
    },
    MensagemFluxoImportacao() {
      if (!this.Status) {
        return '';
      }

      if (this.Status.temCarga || this.Status.temDados) {
        return 'A importação vai substituir a carga institucional atual: limpar dados ins, limpar configurações, carregar o JSON e liberar as telas para os usuários ativos.';
      }

      return 'Base liberada para importação. Após importar, as telas institucionais serão liberadas para os usuários ativos.';
    },
  },
  methods: {
    async CarregarStatus() {
      const response = await axios.get('/Process/ImportacaoInstitucional/Status');
      this.Status = response.data;
    },
    SelecionarArquivo(event) {
      const arquivo = event.target.files && event.target.files[0];
      this.JsonImportacao = null;
      this.NomeArquivo = '';
      this.Resultado = null;

      if (!arquivo) {
        return;
      }

      this.NomeArquivo = arquivo.name;
      const reader = new FileReader();
      reader.onload = () => {
        try {
          this.JsonImportacao = this.NormalizarJsonImportacao(JSON.parse(reader.result));
        } catch {
          this.JsonImportacao = null;
          this.$mensagemAviso('Arquivo JSON inválido.');
        }
      };
      reader.readAsText(arquivo);
    },
    async Importar() {
      if (!this.PodeImportarArquivo) {
        this.$mensagemAviso('Selecione um arquivo JSON para importar.');
        return;
      }

      const result = await this.$mensagemConfirma(
        'Confirma substituir a carga institucional atual? O processo vai limpar os dados ins, limpar as configurações, carregar o JSON e liberar as permissões institucionais para os usuários ativos.'
      );
      if (!result.isConfirmed) {
        return;
      }

      try {
        const response = await axios.post('/Process/ImportacaoInstitucional/Substituir', this.JsonImportacao);
        this.Resultado = response.data;
        await this.AtualizarSessaoUsuario();
        window.dispatchEvent(new CustomEvent('sgcad-menu-refresh'));
        this.$mensagemAvisoSucesso('JSON importado e permissões institucionais atualizadas.');
        await this.CarregarStatus();
      } catch (error) {
        this.$mensagemAviso(this.MensagemErro(error));
      }
    },
    async LimparCarga() {
      if (!this.PodeLimpar) {
        this.$mensagemAviso('Não é possível limpar com a situação atual.');
        return;
      }

      const result = await this.$mensagemConfirma('Tem certeza que deseja limpar toda a carga institucional?');
      if (!result.isConfirmed) {
        return;
      }

      try {
        await axios.delete('/Process/ImportacaoInstitucional/Limpar');
        this.JsonImportacao = null;
        this.NomeArquivo = '';
        this.Resultado = null;
        this.$mensagemAvisoSucesso('Carga institucional limpa.');
        await this.CarregarStatus();
      } catch (error) {
        this.$mensagemAviso(this.MensagemErro(error));
      }
    },
    async GerarJsonFrontend() {
      if (!this.PodeExportarFrontend) {
        this.$mensagemAviso('Importe uma carga institucional antes de gerar o JSON do frontend.');
        return;
      }

      try {
        const response = await axios.get('/Process/ImportacaoInstitucional/ExportarFrontend');
        const conteudo = JSON.stringify(response.data, null, 2);
        const blob = new Blob([conteudo], { type: 'application/json;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const data = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');

        link.href = url;
        link.download = `sgcad-frontend-institucional-${data}.json`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
        this.$mensagemAvisoSucesso('JSON do frontend gerado.');
      } catch (error) {
        this.$mensagemAviso(this.MensagemErro(error));
      }
    },
    MensagemErro(error) {
      return error?.response?.data?.message || error?.response?.data?.Message || 'Operação não realizada.';
    },
    async AtualizarSessaoUsuario() {
      const response = await axios.get('/Auth/Me');
      sessionStorage.setItem('_userav', JSON.stringify({
        cusId: response.data.cusId || response.data.CusId,
        nome: response.data.nome || response.data.Nome,
        urlimage: response.data.urlImage || response.data.UrlImage,
        menu: response.data.menu || response.data.Menu || []
      }));
    },
    CorrigirEncodingTexto(valor) {
      if (typeof valor !== 'string' || !/[��]/.test(valor)) {
        return valor;
      }

      try {
        return decodeURIComponent(escape(valor));
      } catch {
        return valor;
      }
    },
    CorrigirEncodingObjeto(valor) {
      if (typeof valor === 'string') {
        return this.CorrigirEncodingTexto(valor);
      }

      if (Array.isArray(valor)) {
        return valor.map((item) => this.CorrigirEncodingObjeto(item));
      }

      if (valor && typeof valor === 'object') {
        Object.keys(valor).forEach((chave) => {
          valor[chave] = this.CorrigirEncodingObjeto(valor[chave]);
        });
      }

      return valor;
    },
    NormalizarJsonImportacao(json) {
      let payload = this.CorrigirEncodingObjeto(json);

      if (Array.isArray(payload) && payload.length === 1 && payload[0].json) {
        payload = payload[0].json;
      } else if (payload && payload.json) {
        payload = payload.json;
      }

      const moverListasDaConfiguracao = (tela) => {
        if (!tela || !tela.configuracao) {
          return;
        }

        ['listasImagens', 'listasArquivos', 'listasGrids', 'segmentos'].forEach((prop) => {
          if (!tela[prop] && Array.isArray(tela.configuracao[prop])) {
            tela[prop] = tela.configuracao[prop];
          }

          delete tela.configuracao[prop];
        });

        (tela.listasGrids || []).forEach((lista) => {
          (lista.campos || []).forEach((campo) => {
            if (campo.campo === 'igs_link') {
              campo.campo = 'igs_campoextra1';
              campo.label = campo.label || 'Link';
            }
          });
        });
      };

      (payload?.grupos || []).forEach((grupo) => {
        (grupo.telas || []).forEach(moverListasDaConfiguracao);
      });

      return payload;
    },
  },
  created() {
    this.CarregarStatus();
  },
}
</script>

<style scoped>
.import-page {
  background: #f3f5f7;
  min-height: calc(100vh - 80px);
  padding: 28px 32px;
}

.import-card {
  background: #fff;
  border: 1px solid #dbe2ea;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 22px;
}

.import-header {
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-bottom: 18px;
}

.header-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
}

.import-header span {
  color: #64748b;
  display: block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  margin-bottom: 5px;
  text-transform: uppercase;
}

.import-header h1,
.import-header h2 {
  color: #172331;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
}

.status-grid,
.result-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
}

.status-grid article {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 14px;
}

.status-grid span {
  color: #64748b;
  display: block;
  font-size: 12px;
  font-weight: 700;
}

.status-grid strong {
  color: #172331;
  display: block;
  font-size: 24px;
  margin-top: 4px;
}

.status-message,
.clean-message {
  background: #edf7f2;
  border: 1px solid #b9dec9;
  border-radius: 8px;
  color: #1f6b44;
  margin: 16px 0 0;
  padding: 12px 14px;
}

.status-message.blocked {
  background: #fff6e8;
  border-color: #e8c98a;
  color: #8a5b12;
}

.import-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 18px;
}

.file-picker input {
  display: none;
}

.file-picker span {
  align-items: center;
  background: #f8fafc;
  border: 1px dashed #94a3b8;
  border-radius: 8px;
  color: #334155;
  cursor: pointer;
  display: inline-flex;
  min-height: 40px;
  min-width: 240px;
  padding: 8px 12px;
}

.danger-card {
  border-color: #efc3c3;
}

.result-grid span {
  background: #f8fafc;
  border-radius: 6px;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
  padding: 10px;
}

.warning-list {
  color: #8a5b12;
  margin: 14px 0 0;
  padding-left: 18px;
}

@media (max-width: 720px) {
  .import-page {
    padding: 18px 14px;
  }

  .import-header {
    flex-direction: column;
  }

  .header-actions {
    justify-content: flex-start;
  }
}
</style>



